export interface NavMenuItem {
  id: string
  translationKey: string
  path?: string // Optional - not needed for action items
  icon: string // Lucide icon name
  action?: 'openLibrary' // Action to trigger instead of navigation
}

/**
 * Navigation menu items configuration
 * Single source of truth for both desktop and mobile navigation
 */
export const NAV_MENU_ITEMS: NavMenuItem[] = [
  {
    id: 'invitations',
    translationKey: 'invitations',
    path: '/invitations',
    icon: 'Mail',
  },
  {
    id: 'create-invitation',
    translationKey: 'createInvitation',
    path: '/designs',
    icon: 'PlusCircle',
  },
  {
    id: 'my-library',
    translationKey: 'myLibrary',
    icon: 'SquareLibrary',
    action: 'openLibrary',
  },
  {
    id: 'keepsakes',
    translationKey: 'keepsakes',
    path: '/keepsakes',
    icon: 'Gift',
  },
]
